@if (_initialized) {
    <span>
        <span class="lg-year-month-range-selector-popup__year-selector">
            @if (!_config?.singleYearPicking) {
                <span
                    class="lg-year-month-range-selector-popup__select-all"
                    (click)="_selectAll(true)"
                    >{{ ".Year_Month_Range_Selector__All_years" | lgTranslate }}</span
                >
            }
            @for (y of _years; track y) {
                <span
                    #year
                    class="lg-year-month-range-selector-popup__item"
                    [attr.data-id]="y"
                    [ngClass]="_className(y, true)"
                    (mouseover)="_onMouseOver($event, y, true)"
                    (mouseout)="_onMouseOut($event, y, true)"
                    (mousedown)="_onMouseDown(y, true)"
                    title="{{ y }}"
                    (click)="_onClick($event, y, true)"
                    >{{ y }}</span
                >
            }
        </span>
        @if (_showMonthsPicker) {
            <span class="lg-year-month-range-selector-popup__month-selector">
                @if (!_config?.singleMonthPicking) {
                    <span
                        class="lg-year-month-range-selector-popup__select-all"
                        (click)="_selectAll()"
                        >{{ ".Year_Month_Range_Selector__All_months" | lgTranslate }}</span
                    >
                }
                @for (m of _months; track m; let index = $index) {
                    <span
                        #month
                        class="lg-year-month-range-selector-popup__item"
                        [attr.data-id]="index + 1"
                        [ngClass]="_className(index + 1)"
                        (mouseover)="_onMouseOver($event, index + 1)"
                        (mouseout)="_onMouseOut($event, index + 1)"
                        (mousedown)="_onMouseDown(index + 1)"
                        title="{{ _getMonthTooltip(index + 1) | capitalize }}"
                        (click)="_onClick($event, index + 1)"
                        >{{ _shortNames[m] | removeSymbol: "DOT" | capitalize }}</span
                    >
                }
            </span>
        }
    </span>
}
